import { render, staticRenderFns } from "./FotosDocumentos.vue?vue&type=template&id=79405fe0"
import script from "./FotosDocumentos.vue?vue&type=script&lang=js"
export * from "./FotosDocumentos.vue?vue&type=script&lang=js"
import style0 from "./FotosDocumentos.vue?vue&type=style&index=0&id=79405fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports